import type { SeedingDetailProduct, SeedingItem } from '@/app/(activity)/campaigns/[slug]/types';

import type { MaterialGallery2026TrackingParams, MaterialGalleryItem } from './types';

export const MAX_MATERIAL_COUNT = 8;

export const normalizeConfiguredText = (text?: unknown) => {
  if (typeof text !== 'string') return '';

  return text.replace(/<br\s*\/?>/gi, '\n').trim();
};

const isImageMaterial = (mediaType?: string | null) => {
  const normalizedType = mediaType?.trim().toLowerCase();
  return !normalizedType || normalizedType === 'img' || normalizedType === 'image';
};

export function getValidMaterialItems(items?: MaterialGalleryItem[]) {
  return (items ?? [])
    .map((item, originalIndex) => ({ item, originalIndex }))
    .filter(({ item }) => {
      const itemId = Number(item.id);
      const validMaterialCount = Number(item.valid_material_count);

      return (
        Number.isFinite(itemId) &&
        itemId > 0 &&
        Boolean(item.jump_image?.trim()) &&
        Number.isFinite(validMaterialCount) &&
        validMaterialCount > 0 &&
        isImageMaterial(item.media_type)
      );
    })
    .slice(0, MAX_MATERIAL_COUNT);
}

export function buildSeedingSummaryMap(items?: SeedingItem[]) {
  const summaryMap = new Map<number, SeedingItem>();

  for (const item of items ?? []) {
    const itemId = Number(item.item_id ?? item.id);
    if (Number.isFinite(itemId) && itemId > 0) {
      summaryMap.set(itemId, item);
    }
  }

  return summaryMap;
}

export function buildMaterialTrackingParams({
  item,
  originalIndex,
  componentId,
  moduleId,
  moduleTitle,
  moduleIndex,
  product,
}: {
  item: MaterialGalleryItem;
  originalIndex: number;
  componentId: string;
  moduleId: string;
  moduleTitle: string;
  moduleIndex: number;
  product?: SeedingDetailProduct;
}): MaterialGallery2026TrackingParams {
  return {
    module_index: moduleIndex,
    module_name: componentId,
    module_id: moduleId,
    module_title: moduleTitle,
    mkt_index: originalIndex,
    mkt_index_sub: '',
    mkt_jump_type: '2',
    mkt_jump_content: item.shop_sku || product?.shop_sku || '',
    module_tab_name: '',
    coupon_id_list: '',
    coupon_name_list: '',
    shop_sku: item.shop_sku || product?.shop_sku || '',
    business_sku: product?.business_sku || '',
    product_sku: product?.sku || '',
    product_id: String(product?.id || ''),
    product_name: product?.short_name || product?.name || '',
    group_id: '',
    group_name: '',
  };
}

export function buildGalleryPageTrackingParams({
  componentId,
  moduleId,
  moduleTitle,
  moduleIndex,
  pageUrl,
}: {
  componentId: string;
  moduleId: string;
  moduleTitle: string;
  moduleIndex: number;
  pageUrl: string;
}): MaterialGallery2026TrackingParams {
  return {
    module_index: moduleIndex,
    module_name: componentId,
    module_id: moduleId,
    module_title: moduleTitle,
    mkt_index: 0,
    mkt_index_sub: 'page',
    mkt_jump_type: '4',
    mkt_jump_content: pageUrl,
    module_tab_name: '',
    coupon_id_list: '',
    coupon_name_list: '',
    shop_sku: '',
    business_sku: '',
    product_sku: '',
    product_id: '',
    product_name: '',
    group_id: '',
    group_name: '',
  };
}
